import React from "react";
import { LearningRecordSimulation, SimulationAssessmentReport } from "src/types/coaching/learners";

export interface SimulationContextProps {
  id?: string;

  view: "summary" | "simulator" | 'completion' | "report" | "failed";
  startingSimulation?: boolean;
  enrollingSimulation?: boolean;
  endingSimulation?: boolean;
  restartingSimulation?: boolean;
  retakingSimulation?: boolean;

  fetchingReport?: boolean;
  fetchedReport?: boolean;

  assessmentReport?: SimulationAssessmentReport;

  // eslint-disable-next-line no-unused-vars
  changeView? : (view: "summary" | "simulator" | 'completion' | "report" | "failed") => void;

  enrollSimulation?: () => void;
  startSimulation?: () => void;
  retakeSimulation?: () => void;
  restartSimulation?: () => void;
  resumeSimulation?: () => void;
  // eslint-disable-next-line no-unused-vars
  endSimulation?: (simulation: LearningRecordSimulation) => void;

  viewReport?: () => void;

  // eslint-disable-next-line no-unused-vars
  onBack?: () => void;
}

export const SimulationContext = React.createContext<SimulationContextProps>({
  view: "summary",
});